import { render, staticRenderFns } from "./HostEvent.vue?vue&type=template&id=b427740c&"
import script from "./HostEvent.vue?vue&type=script&lang=ts&"
export * from "./HostEvent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HostEvent.vue"
export default component.exports